import { Category } from '@wix/answers-api';

import { PageTemplateData } from '../components/PageTemplate';
import {
  EXCLUDED_CATEGORIES,
  TWINS_CATEGORY_ID,
  WIXEL_CATEGORY_ID,
} from '../constants';
import { findCategoryInTreeById, getCategoriesPaths } from './categories';
import { PageType } from '../types';

export const isExcludedCategoryInPath = (
  pageType: PageType,
  categories: Category[],
  pageTemplateData: PageTemplateData,
  excludedCategories: string[] = EXCLUDED_CATEGORIES
): boolean => {
  if (pageType === PageType.Category) {
    const currentCategoryId = pageTemplateData.itemId;
    const categoriesPath = currentCategoryId
      ? getCategoriesPaths(categories, [currentCategoryId])[
          currentCategoryId
        ].filter((pathItem) => !!pathItem)
      : false;

    const isExcludedCategoryPage =
      currentCategoryId && excludedCategories.includes(currentCategoryId);
    const isExcludedSubCategoryPage =
      categoriesPath && currentCategoryId
        ? excludedCategories.some(
            (excludedId) => !!findCategoryInTreeById(categoriesPath, excludedId)
          )
        : false;

    return isExcludedCategoryPage || isExcludedSubCategoryPage;
  }
  if (pageType === PageType.Article) {
    const currentCategoryId = pageTemplateData?.pageData?.article?.categoryId;
    const categoriesPath = currentCategoryId
      ? getCategoriesPaths(categories, [currentCategoryId])[
          currentCategoryId
        ].filter((pathItem) => !!pathItem)
      : false;
    const isExcludedSubCategoryPage =
      categoriesPath && currentCategoryId
        ? excludedCategories.some(
            (excludedId) => !!findCategoryInTreeById(categoriesPath, excludedId)
          )
        : false;
    return isExcludedSubCategoryPage;
  }
  return false;
};

export const isExcludedCategory = (categoryId: string): boolean =>
  EXCLUDED_CATEGORIES.includes(categoryId);

export const filterExcludedCategories = (categories: Category[]) =>
  categories.filter((category) => !isExcludedCategory(category.id));

export const isWixelRelated = (
  pageType: PageType,
  categories: Category[],
  pageTemplateData: PageTemplateData
): boolean =>
  isExcludedCategoryInPath(pageType, categories, pageTemplateData, [
    WIXEL_CATEGORY_ID,
  ]);

export const isTwinsRelated = (
  pageType: PageType,
  categories: Category[],
  pageTemplateData: PageTemplateData
): boolean =>
  isExcludedCategoryInPath(pageType, categories, pageTemplateData, [
    TWINS_CATEGORY_ID,
  ]);
